import type { FC } from 'react'
import cc from 'classcat'
import type { Variants } from 'framer-motion'
import { AnimatePresence, motion } from 'framer-motion'

import styles from './form-error-message.module.scss'

const error_animation: Variants = {
  initial: {
    height: '0',
  },
  animate: {
    height: 'auto',
    transition: {
      default: { duration: 0.25 },
    },
  },
  exit: {
    height: '0',
    transition: {
      default: { duration: 0.25 },
    },
  },
}

interface FormErrorMessageProps {
  error?: string
  className?: string
}

const FormErrorMessage: FC<FormErrorMessageProps> = ({ error, className }) => (
  <AnimatePresence>
    {Boolean(error) && (
      <motion.span
        className={cc([styles.form_error_wrapper__error, className])}
        variants={error_animation}
        initial='initial'
        animate='animate'
        exit='exit'
      >
        {error}
      </motion.span>
    )}
  </AnimatePresence>
)

export default FormErrorMessage
